import { render, staticRenderFns } from "./NewEditTurmaPage.vue?vue&type=template&id=7675a45d"
import script from "./NewEditTurmaPage.vue?vue&type=script&lang=js"
export * from "./NewEditTurmaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports